module.exports = __webpack_public_path__ + "img/vertical_6_2_9006.82136084.png";